import { FeatureFlagIds } from "../../utils/featureFlagIds";
import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { useConfiguration } from '../../Data/ConfigurationData';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { AppState } from '../../store/rootReducer';
import { useDispatch, useSelector } from 'react-redux';
import { requestDocuments } from '../../Data/ApplicationDocumentData';
import { ApplicationDispatch, SET_LOADING } from '../../store/application/types';
import TextField from '@mui/material/TextField';
import { useApplicationCustomerStipulations } from '../../Data/StipulationData';
import { Constants, permissions } from '../../utils/constants';
import { userHasPermission } from '../../utils/utils';
import { postMergePdf } from '../../Data/MergePdfData';
import { PermissionSet } from '@amsanalytics/react-shared-library';

export interface RequestDocumentsProps {
}

export const RequestDocuments: React.FC<RequestDocumentsProps> = props => {
  const dispatch = useDispatch<ApplicationDispatch>();
  const currentApp = useSelector((state: AppState) => state.applications.editingApp);
  const appCustomers = currentApp?.appCustomers;
  const [toNumber, setToNumber] = useState('');
  const [type, setType] = useState('App Stips');
  const [isRequestingDocuments, setIsRequestingDocuments] = useState(false);
  const { data: configuration } = useConfiguration();
  const isRequestDocumentsActive = configuration?.featureFlags?.[FeatureFlagIds.TextMessages] || false;
  const currentUser = useSelector((state: AppState) => state.applications.loggedInUser?.employee);
  const userCanViewMergeButton = userHasPermission(currentUser!, permissions.mergePdfDocuments, PermissionSet.R);

  const firstPreferredCustomerPhone = appCustomers
    ?.map(ac => ac.customer?.customerPhone?.find(cp => cp.isPreferred && !cp.doNotText))
    ?.find(cp => cp && cp.isPreferred && !cp.doNotText);

  useEffect(() => {
    if (!toNumber && firstPreferredCustomerPhone?.phoneNumber) {
      setToNumber(firstPreferredCustomerPhone.phoneNumber);
    }
  }, [toNumber, firstPreferredCustomerPhone]);

  const { data: stipulationData } = useApplicationCustomerStipulations(currentApp ? currentApp.id : Constants.emptyGuid);

  const handleMergeRequest = async () => {
    if (currentApp) {
      dispatch({ type: SET_LOADING, payload: true });
      await postMergePdf(dispatch, currentApp?.id!);
      dispatch({ type: SET_LOADING, payload: false });
    }
  };

  if (isRequestDocumentsActive) {
    return (
    <>
      <Button style={{ margin: 10 }}
        onClickCapture={(e) => {
          e.stopPropagation();
          setIsRequestingDocuments(true);
        }}
        size="small"
        variant="contained"

      >
        Request Documents
      </Button>
      { userCanViewMergeButton &&
      <Button style={{ margin: 10 }}
        onClick={handleMergeRequest}
        size="small"
        variant="contained"

      >
        Merge Documents
      </Button>
      }
      <Dialog open={isRequestingDocuments}
        onClose={() => {
          setIsRequestingDocuments(false);
        }}
      >
        <DialogTitle>Request missing documents via text message?</DialogTitle>
        <DialogContent>
          <TextField
            value={toNumber}
            onChange={(e) => {
              setToNumber(e.target.value);
            }}
            select
            variant="outlined"
            label="Phone Number"
            fullWidth
            size="small"
            style={{
              marginTop: 8,
            }}
            SelectProps={{
              native: true,
            }}
          >
            {/* <option>&nbsp;</option> */}
            {appCustomers?.map((ac, key) =>
              ac.customer?.customerPhone
              ?.filter(cp => !cp.doNotText)
              ?.map(cp =>
              <option key={key} value={cp.phoneNumber}>{cp.phoneNumber} ({ac.customer.firstName} {ac.customer.lastName}{cp.isPreferred ? ' - Preferred': ''})</option>
              )
            )}
          </TextField>
          <TextField
            value={type}
            onChange={(e) => {
              setType(e.target.value);
            }}
            select
            variant="outlined"
            label="Stip Type"
            fullWidth
            size="small"
            style={{
              marginTop: 10,
            }}
            SelectProps={{
              native: true,
            }}
          >
            {stipulationData?.stipulationCategoryTypes?.map((t, key) =>
            <option key={key}>{t.name}</option>
            )}
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button color="inherit" variant='outlined' onClick={() => {
            setIsRequestingDocuments(false);
          }}>
            Cancel
          </Button>
          <Button color="primary" variant='contained' onClick={async () => {
            setIsRequestingDocuments(false);
            try {
              await requestDocuments(currentApp?.id || '', toNumber, type);
            } catch (err) {
              dispatch({ type: "SET_SERVER_MESSAGE", payload: { message: err as string, isError: true } });
            }
          }}>
            Request
          </Button>
        </DialogActions>
      </Dialog>
    </>
    );
  } else {
    return null;
  }
}
